//@flow
import React, { Component, type Element } from 'react';
import { Tablet } from '../../../Responsive';
import { CustomModelListTd, ToggleDetails } from '../../StatisticsStyles';
import DefaultModelRowTr from '../../../../modules/CrudTable/components/DefaultModelRowTr';

type Props = {
  options: Array<{ value: string | Element<any> }>,
  noBorder?: boolean,
  first?: boolean,
  bold?: boolean,
  detailToggled?: string,
  setToggleState?: () => void
};

export default class TableRowDevicePartial extends Component<Props> {
  static defaultProps = { noBorder: true };

  render() {
    return (
      <DefaultModelRowTr>
        <CustomModelListTd
          // right
          noBorder={this.props.noBorder}
          first={this.props.first}
          bold={this.props.bold}
        >
          {this.props.options[0].value}
        </CustomModelListTd>
        <Tablet>
          <CustomModelListTd
            right
            noBorder={this.props.noBorder}
            first={this.props.first}
            bold={this.props.bold}
          >
            {this.props.options[1].value}
          </CustomModelListTd>
        </Tablet>

        <CustomModelListTd
          right
          noBorder={this.props.noBorder}
          first={this.props.first}
          bold={this.props.bold}
        >
          {this.props.options[2].value === 'toggle' ? (
            <ToggleDetails
              iconName={
                this.props.detailToggled
                  ? 'minusCircleThick'
                  : 'plusCircleThick'
              }
              text="Details"
              activeText="Hide"
              inActiveText="View"
              setToggleState={this.props.setToggleState}
              toggleState={this.props.detailToggled}
            />
          ) : (
            this.props.options[2].value
          )}
        </CustomModelListTd>
      </DefaultModelRowTr>
    );
  }
}
